import { Trash2, Loader2, FileText } from 'lucide-react';
import MiniPagePreview from './MiniPagePreview';
import { getTemplateFirstPage } from './storyUtils';

export default function TemplateGridCard({ template, onUse, onDelete, creatingId, getCategoryGradient }) {
  const fp = getTemplateFirstPage(template);
  const hasPreview = fp.layers.length > 0 || fp.background;

  return (
    <div className="flex flex-col">
      <div
        className="group relative rounded-xl overflow-hidden cursor-pointer transition-all duration-200"
        style={{
          aspectRatio: '9/16',
          border: '1px solid var(--t-border)',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.14)';
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.borderColor = 'var(--brand-primary)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.borderColor = 'var(--t-border)';
        }}
      >
        {hasPreview ? (
          <MiniPagePreview background={fp.background} layers={fp.layers} />
        ) : (
          <div className="w-full h-full flex items-center justify-center"
            style={{ background: getCategoryGradient(template.category) }}>
            <FileText size={32} className="text-white/40" />
          </div>
        )}

        <div className="absolute top-2 left-2 px-1.5 py-0.5 rounded text-[10px] font-semibold"
          style={{ background: 'rgba(0,0,0,0.5)', color: '#fff', backdropFilter: 'blur(4px)' }}>
          {template.category}
        </div>

        <div className="absolute top-2 right-2 px-1.5 py-0.5 rounded text-[10px] font-semibold"
          style={{ background: 'rgba(0,0,0,0.5)', color: '#fff', backdropFilter: 'blur(4px)' }}>
          {template.pages.length} pg{template.pages.length !== 1 ? 's' : ''}
        </div>

        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200
                        flex flex-col justify-between p-2.5"
          style={{ background: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.75) 100%)' }}>
          {onDelete ? (
            <div className="flex justify-end gap-1">
              <button
                onClick={e => onDelete(template.id, e)}
                className="w-7 h-7 bg-red-500/70 hover:bg-red-500/90 rounded-md flex items-center justify-center backdrop-blur-sm transition-colors"
                title="Delete template"
              >
                <Trash2 size={11} className="text-white" />
              </button>
            </div>
          ) : <div />}
          <button
            onClick={(e) => { e.stopPropagation(); onUse(template); }}
            disabled={creatingId === template.id}
            className="w-full py-2 rounded-lg text-xs font-semibold transition-colors"
            style={{ background: 'var(--brand-primary)', color: '#fff' }}
          >
            {creatingId === template.id ? (
              <span className="flex items-center justify-center gap-1.5">
                <Loader2 size={11} className="animate-spin" /> Creating...
              </span>
            ) : 'Use Template'}
          </button>
        </div>
      </div>

      <div className="mt-1.5 px-0.5">
        <p className="text-xs font-medium truncate" style={{ color: 'var(--t-text)' }}>
          {template.name}
        </p>
        <p className="text-[10px] truncate" style={{ color: 'var(--t-muted)' }}>
          {template.pages.length} page{template.pages.length !== 1 ? 's' : ''}
          {template.description ? ` · ${template.description}` : ''}
        </p>
      </div>
    </div>
  );
}
